import { useState } from 'react';
import { usePosts } from '../../hooks/usePosts';
import PostInfo from '../Blog/PostInfo';
import useText from '@/hooks/useText';
import he from 'he';
import Loader from '../Common/Loader';

const PostImg = ({ image }) => <img src={image} alt="Post" className="blog-home-card-img" />;

// Función helper para determinar posts por página
const getPostsPerPage = () => {
  // Usar optional chaining y un fallback para tests
  if (typeof window !== 'undefined' && window.matchMedia) {
    if (window.matchMedia('(max-width: 1025px)').matches) {
      return 2;
    }
  }
  return 3; // valor por defecto
};

export default function BlogHome() {
  const { posts } = usePosts();
  const [currentStartIndex, setCurrentStartIndex] = useState(0);
  const blogLabel = useText('home.blog.label');
  const blogTitle = useText('home.blog.title');
  const readMore = useText('home.blog.read_more');
  const loading = useText('home.blog.loading');

  if (!posts || posts.length === 0) {
    return (
      <section id="blog" className="home-blog-section">
        <div className="text-center">
          <span className="home-blog-label">{blogLabel}</span>
          <h2 className="home-section-title home-blog-title">{blogTitle}</h2>
        </div>
        <div className="blog-home-container">
          <Loader text={loading} isInnerSpinner />
        </div>
      </section>
    );
  }

  const postsPerPage = getPostsPerPage();

  const totalPages = Math.ceil(posts.length / postsPerPage);

  const handleDotClick = index => {
    setCurrentStartIndex(index * postsPerPage);
  };

  const visiblePosts = posts.slice(currentStartIndex, currentStartIndex + postsPerPage);

  return (
    <section id="blog" className="home-blog-section">
      <div className="text-center">
        <span className="home-blog-label">{blogLabel}</span>
        <h2 className="home-section-title home-blog-title">{blogTitle}</h2>
      </div>
      <div className="blog-home-container">
        <div className="blog-home-cards blog-home-cards-elevated">
          {visiblePosts.map(post => (
            <article key={post.postName} className="blog-home-card blog-home-card-modern visible">
              <a href={`${post.link}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="blog-home-card-header">
                  <PostImg image={post.image} />
                </div>
                <div className="blog-home-card-content">
                  <h3 className="blog-home-card-title gradient-color h3-post">{he.decode(post.title)}</h3>
                  <p className="blog-home-card-description">{he.decode(post.description)}</p>
                  <div className="blog-home-card-meta">
                    <PostInfo category={post.category} date={post.date} />
                  </div>
                  <span className="blog-home-read-more">{readMore}</span>
                </div>
              </a>
            </article>
          ))}
        </div>
        <div className="slider-dots">
          {Array.from({ length: totalPages }).map((_, index) => (
            <div
              key={index}
              className={`slider-dot ${currentStartIndex / postsPerPage === index ? 'active' : ''}`}
              onClick={() => handleDotClick(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
